import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import type { ReactNode } from 'react';

const SemiBoldText = (chunks: ReactNode) => (
  <Text variant="dashboardBodySm" fontWeight="semiBold">
    {chunks}
  </Text>
);

export function BankTransferPaymentMethod({ email }: { email: string }) {
  const t = useTranslations('purchasing.legacy.checkoutUiPackage');

  return (
    <Box width="100%">
      <Text variant="dashboardBodySm">
        {t.rich('checkout_modal.payment_method.bank_transfer', {
          email,
          bold: SemiBoldText,
        })}
      </Text>
    </Box>
  );
}
